import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Payable } from 'services/action';

import { Page, Button } from 'ui/components';
import { FormGeneral, FormNote, FormSubtotal } from './component/form';

const initialState = {
  general: null,
  note: null,
  payment: null,
  isLoading: true,
};

const CreateScreen = () => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);

  const [{ general, note, payment, isLoading }, setState] =
    React.useState(initialState);

  const $handleSubmit = async (e) => {
    const payload = {
      type: general?.type,
      vendor_id: general?.vendor?.id,
      purchase_order_id: general?.purchaseOrder?.id,
      ref_code: general?.ref_code,
      projects: general?.projects,
      periode_project_at: general?.periode_project_at?.formatted,
      schedule_at: general?.schedule_at?.formatted,
      term_of_payment: general?.term_of_payment?.value || 0,
      due_at: general?.due_at?.formatted,
      nominal: payment?.nominal || 0,
      discount: payment?.discount || 0,
      ppn: payment?.ppn,
      pph: payment?.pph,
      down_payment: payment?.down_payment,
      ...note,
    };

    const req = await Dispatch(Payable.$create(payload));

    if (req?.message === 'success') {
      History?.push(`/payable/${req?.data?.id}`);
    }
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, []);

  return (
    <Page type="form" onSubmit={$handleSubmit} className="detail-fixed">
      <Page.Header title="Buat Payable" className="bg-light" />

      <Page.Body className="d-block row px-3">
        <FormGeneral
          onChange={(e) =>
            setState((prevState) => ({ ...prevState, general: e }))
          }
          isLoading={isLoading}
        />

        <div className='row'>
          <div className='col-6'>
            <FormNote
              onChange={(e) =>
                setState((prevState) => ({ ...prevState, note: e }))
              }
              isLoading={isLoading}
            />
          </div>
          <div className='col-6'>
            <FormSubtotal
              onChange={(e) =>
                setState((prevState) => ({ ...prevState, payment: e }))
              }
              isLoading={isLoading}
            />
          </div>
        </div>
      </Page.Body>
      <Page.Footer className="bg-light justify-content-center gap-md-2 pt-2 pb-3 mb-2 mb-md-0 border-top d-md-flex d-block flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/receivable`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default CreateScreen;
